import { Divider } from '@mui/material';
import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { FormBuilder } from '@act/storybook';
import SurveyTitleSection from '../../surveys/SurveyTitleSection';
import SurveyStepper from '../../surveys/SurveyStepper';
import SurveyResponseSummaryView from '../../surveys/SurveyResponseSummaryView';
import { FormConfig } from 'stories/forms/FormBuilder/FormBuilder.types';
import { Control, FormState } from 'react-hook-form';
import z from 'zod';

export const notesSchema = z.object({
  notes: z.string().optional(),
});

export type NotesForm = z.infer<typeof notesSchema>;

interface AssignedSurveyContentProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
  member: UserDto;
  isReviewMode?: boolean;
  submittingForm: boolean;
  onFormStateChange?: (isDirty: boolean) => void;
  control: Control<NotesForm>;
  formState: FormState<NotesForm>;
  handleAutoSave?: (autoSaveNote: string) => Promise<void>;
}

export const AssignedSurveyContent = ({
  assignedSurvey,
  member,
  isReviewMode = false,
  submittingForm,
  onFormStateChange,
  control,
  formState,
  handleAutoSave,
}: AssignedSurveyContentProps) => {
  const { survey } = assignedSurvey || {};

  const formConfig: FormConfig<NotesForm> = [
    {
      type: 'input',
      name: 'notes',
      label: 'Notes',
      input: 'richText',
      props: {
        autoSaveFn: handleAutoSave,
        showCharacterCount: false,
      },
    },
  ];

  return (
    <>
      <SurveyTitleSection survey={survey} member={member} />
      {!isReviewMode && (
        <SurveyStepper
          assignedSurvey={assignedSurvey}
          submittingForm={submittingForm}
          onFormStateChange={onFormStateChange}
        />
      )}
      {isReviewMode && (
        <SurveyResponseSummaryView assignedSurvey={assignedSurvey} />
      )}
      <Divider sx={{ margin: '24px -12px 8px' }} />
      <FormBuilder
        config={formConfig}
        control={control}
        formState={formState}
      />
    </>
  );
};
